import {ValidatorFn, AbstractControl} from '@angular/forms';

export class GlobalValidator {
  static PASSWORD_MAX_LENGTH: 20;
  static PASSWORD_MIN_LENGTH: 5;
  static mailFormat(formControl: AbstractControl): ValidationResult {

    const EMAIL_REGEXP =  /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (formControl.value !== null && formControl.value !== '' && (formControl.value.length <= 5
      || !EMAIL_REGEXP.test(formControl.value))) {
      return {'incorrectMailFormat': true};
    }

    return null;
  }


  static  numberBetween(min, max) {
    return (c: AbstractControl): ValidationResult => {
      return c.value >= min && c.value <= max ? null : {'invalidRange': false};
    };
  };
  static  min(minvalue) {
    return (c: AbstractControl): ValidationResult => {
      return c.value >= minvalue  ? null : {'min': true};
    };
  };
  static  max(maxvalue) {
    return (c: AbstractControl): ValidationResult => {
      return c.value > maxvalue ? {'max': true} : null;
    };
  };

  static noSpecialCharacters(control: AbstractControl) {
    const specialCharacterCheck = /[^a-zA-Z\-\/]/;

    if (control.value !== '' && (specialCharacterCheck.test(control.value))) {
      return {'specialCharacter': true};
    }

    return null;
  }
  static jsonKeyValidation(control: AbstractControl) {
    const specialCharacterCheck = /[^A-Za-z0-9\-]+/;

    if ((control.value && control.value !== '') && (specialCharacterCheck.test(control.value))) {
      return {'jsonKey': true};
    }

    return null;
  }

  static consecutiveSpace(control: AbstractControl) {
    const CONSECUTIVE_SPACES = /\s\s/;
    if (CONSECUTIVE_SPACES.test(control.value)) {
      return {'consecutiveSpace': true};
    }
    return null;
  }

  static alphanumeric(control: AbstractControl) {
    const ALPHA_NUM_REGEX = /.*[0-9].*/;

    if (control.value && control.value !== '' && (control.value.length < 5 ||
      !ALPHA_NUM_REGEX.test(control.value))) {
      return {'invalidAlphaNumeric': true};
    }

    return null;
  }

  static hasOnlySpace(control: AbstractControl) {
    let EXP = /\S/;
    if (!EXP.test(control.value)) {
      return {'onlySpace': true};
    }
  }
  public static numberValidation(control: AbstractControl): ValidationResult {
    if (isNaN(control.value)) {
      return { 'numberValidation': true };
    }
    return null;
  }

  public static integerValidation(control: AbstractControl): ValidationResult {
    if (!(parseInt(control.value) == control.value)) {
      return { 'integerValidation': true };
    }
    return null;
  }

  public static isNaturalNumber(control: AbstractControl): ValidationResult {
    let num = control.value.toString(); // force the value incase it is not
    let  num1 = Math.abs(num),
      num2 = parseInt(num, 10);
    return {'isNatural': !(!isNaN(num1) && num2 === num1 && num1.toString() === num)};
  }
}
export interface ValidationResult {
  [key: string]: boolean;
}



// WEBPACK FOOTER //
// ./src/app/shared/validators/global-validator.ts